import { CHANNEL_TYPE_PARAM_VALUE_MUTATION_TAG } from './channelTypeParamValuesApi';
import { dcpcApi } from './dcpcApi';

export const CHANNEL_TYPE_PARAMS_TAG = 'ChannelTypeParams';
export const CHANNEL_TYPE_PARAMS_MUTATION_TAG = 'ChannelTypeParamsMutation';

dcpcApi.enhanceEndpoints({ addTagTypes: [CHANNEL_TYPE_PARAMS_TAG, CHANNEL_TYPE_PARAMS_MUTATION_TAG] });

const channelTypeParamsApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getChannelTypeParamById: builder.query({
      query: (id) => `channel-type-params/${id}`,
      providesTags: [CHANNEL_TYPE_PARAMS_TAG, CHANNEL_TYPE_PARAMS_MUTATION_TAG],
    }),

    updateChannelTypeParam: builder.mutation({
      query: ({ id, body }) => ({
        url: `channel-type-params${id ? `/${id}` : ''}`,
        method: id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [CHANNEL_TYPE_PARAMS_TAG, CHANNEL_TYPE_PARAMS_MUTATION_TAG],
    }),

    deleteChannelTypeParamById: builder.mutation({
      query: (id) => ({
        url: `channel-type-params/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CHANNEL_TYPE_PARAMS_TAG, CHANNEL_TYPE_PARAMS_MUTATION_TAG],
    }),

    getChannelTypeParamValuesByChannelTypeParamId: builder.query({
      query: (id) => `channel-type-params/${id}/values`,
      providesTags: [CHANNEL_TYPE_PARAM_VALUE_MUTATION_TAG],
    }),
  }),
});

export const {
  useGetChannelTypeParamByIdQuery,
  useUpdateChannelTypeParamMutation,
  useDeleteChannelTypeParamByIdMutation,
  useGetChannelTypeParamValuesByChannelTypeParamIdQuery,
} = channelTypeParamsApi;
